import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { SuggestionCard } from "@evyely/ui";
export function SuggestionStream({ suggestion, isStreaming, onFeedback }) {
    const containerRef = useRef(null);
    useEffect(() => {
        if (isStreaming && containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [suggestion, isStreaming]);
    if (!suggestion && !isStreaming)
        return null;
    return (_jsx("div", { ref: containerRef, style: { overflowY: "auto", maxHeight: 400 }, children: _jsx(SuggestionCard, { suggestion: suggestion, isStreaming: isStreaming, onFeedback: onFeedback }) }));
}
